// 问卷表单的题目类型
export enum QuestionnaireSubjectType {
  multi_radio = 'multi_radio', // 多选题
  single_choice = 'single_choice', // 文本单选题
  select = 'select', // 上下滚动题
  text = 'text', // 文本题
  number = 'number', // 数字输入题
  enclosure = 'enclosure', // 附件题
  address = 'address', // 地址选择题
  date = 'date', // 日期时间选择
  description = 'description', // 说明文字题
}

export const QUESTION_TYPES_ARR = [
  {
    value: QuestionnaireSubjectType.single_choice,
    label: '单选题',
  },
  {
    value: QuestionnaireSubjectType.multi_radio,
    label: '多选题',
  },
  {
    value: QuestionnaireSubjectType.select,
    label: '上下滚选题',
  },
  {
    value: QuestionnaireSubjectType.text,
    label: '输入文本题',
  },
  {
    value: QuestionnaireSubjectType.number,
    label: '数字输入题',
  },
  {
    value: QuestionnaireSubjectType.enclosure,
    label: '附件题（图片/视频）',
  },
  {
    value: QuestionnaireSubjectType.address,
    label: '地址选择题',
  },
  {
    value: QuestionnaireSubjectType.date,
    label: '日期时间选择题',
  },
  {
    value: QuestionnaireSubjectType.description,
    label: '说明文字题',
  },
];

// 题目层级
export enum QuestionLevel {
  firstLevel = '1',
  secondLevel = '2',
  thirdLevel = '3',
  fourLevel = '4',
}

// 执行时间
export enum ExecutionTime {
  custom,
  allTime,
  conditionalTrigger,
}

// 条件触发
export enum ConditionalTrigger {
  inHospitalData = 'innerHospitalData',
  materialTime = 'keyDate',
  innerSystem = 'innerSystem',
  partnerKeyDate = 'partnerKeyDate',
}

// 执行时间选项
export const EXECUTION_TIME_LIST = [
  { value: ExecutionTime.allTime, label: '全部时段' },
  { value: ExecutionTime.custom, label: '自定义' },
  { value: ExecutionTime.conditionalTrigger, label: '条件触发' },
];

// 条件触发选项
export const CONDITIONAL_TRIGGER_LIST = [
  { value: ConditionalTrigger.inHospitalData, label: '院内数据触发' },
  { value: ConditionalTrigger.materialTime, label: '关键时间' },
  { value: ConditionalTrigger.innerSystem, label: '系统内条件' },
  { value: ConditionalTrigger.partnerKeyDate, label: '机构数据触发(关键时间)' },
];

/*
 ** 计划类型
 ** 0未知（表单）｜1周期循环｜2自定义
 */
export enum PlanType {
  unknown,
  cycle,
  custom,
}

// 计划类型选项
export const PLAN_TYPE_LIST = [
  { value: PlanType.cycle, label: '周期循环' },
  { value: PlanType.custom, label: '自定义' },
];

// 结束时间
export const REMINDER_END_UNIT_LIST = [
  {
    value: '天',
    label: '天',
  },
  {
    value: '周',
    label: '周',
  },
  {
    value: '月',
    label: '月',
  },
  {
    value: '年',
    label: '年',
  },
  {
    value: '长期',
    label: '长期',
  },
];

// 随访计划周期
export const PLANNING_CYCLE_LIST = ['一天', '一周', '两周', '一个月', '三个月', '半年', '一年', '三年'];

// 标题限制长度
export const getTitleMaxLength = (type: QuestionnaireSubjectType) => {
  if (type === QuestionnaireSubjectType.description) return 200;
  return 50;
};

export enum QuestionnaireTemplate {
  questionnaire = 'questionnaire',
}

export const PERMISSIONS_LIST = [
  {
    value: 'myself',
    label: '仅本人查看',
  },
  {
    value: 'current_department',
    label: '仅本科室查看',
  },
  {
    value: 'current_hospital',
    label: '仅本医院查看',
  },
  {
    value: 'all',
    label: '全部查看',
  },
];

export enum ImportStatus {
  INITIAL = -100, // 初始值
  WAITING = 0, // 未开始
  RUNNING = 1, // 运行中
  SUCCESS = 2, // 已完成
  FAILED = 3, // 失败
  TIMEOUT = 4, // 超时
}

export const PATIENT_SOURCE_LIST = [
  {
    value: 'outpatient',
    label: '门诊',
  },
  {
    value: 'emergency',
    label: '  急诊',
  },
  {
    value: 'inpatient',
    label: '住院',
  },
  {
    value: 'physicalExam',
    label: '体检',
  },
];

export const GENDER_LIST = [
  {
    value: 0,
    label: '不限',
  },
  {
    value: 1,
    label: '男',
  },
  {
    value: 2,
    label: '女',
  },
];

export const TREATMENT_PROCESS_LIST = [
  {
    value: 0,
    label: '就诊',
  },
  {
    value: 1,
    label: '入院',
  },
  {
    value: 2,
    label: '离院',
  },
];

// 患者导入方式
export enum ImportPatientsType {
  manual = 'manual',
  automatic = 'automatic',
}

export const REGULAR_INSPECTION_LIST = [
  {
    value: 'basicInfo',
    label: '基本',
  },
  {
    value: 'internalMed',
    label: '内科',
  },
  {
    value: 'surgeryMed',
    label: '外科',
  },
];

// 包含关系列表
export const CONTAIN_RELATIONSHIP_LIST = [
  {
    value: '=',
    label: '包含',
  },
  {
    value: '!',
    label: '不包含',
  },
];

// 逻辑关系列表
export const LOGICAL_RELATIONSHIP_LIST = [
  {
    value: '&',
    label: '并且',
  },
  {
    value: '|',
    label: '或者',
  },
];

// 待确定患者 指定列表的类型：-1-无任务 0-存量任务, 1-增量任务
export enum PatientToBeDetermined {
  noTask = -1,
  stock,
  incremental,
}

// 诊断过程匹配规则
export const DiagnosticRule = {
  doctorAdvice: [],
  physicalExaminationConclusion: [
    '$(physicalExam.physicalExamResults.name)',
    '$(physicalExam.physicalExamResults.dec)',
  ],
  inspectionConclusion: ['$(physicalExam.examSummaries.desc)'],
  regularInspection: [
    '$(physicalExam.regularExam.variable.summary)',
    '$(physicalExam.regularExam.variable.summary)',
    '$(physicalExam.regularExam.variable.summary)',
  ],
  diagnose: [
    '$(outpatient.preliminaryDiagnosis)',
    '$(frontSheet.dischargeDiagnosisMain)',
    '$(inpatient.preliminaryDiagnosis)',
    '$(inpatient.admitDiagnosis)',
    '$(inpatient.diagnosis)',
  ],
  operation: [
    '$(frontSheet.surgeryAndOpName)',
    '$(inpatient.plan)',
    '$(outpatient.plan)',
    '$(inpatient.medicalRecordBrief)',
  ],
  prescriptionDrugs: ['$(inpatient.recipe)', '$(inpatient.drug)', '$(outpatient.recipe)', '$(outpatient.drug)'],
  handlingOpinions: ['$(inpatient.plan)', '$(outpatient.plan)', '$(inpatient.medicalRecordBrief)'],
};

/*
 ** 计划加入状态
 ** inviting:  邀请中
 ** following: 随访中
 ** rejected:  已拒绝
 ** removed:   已移除
 ** expired:   已到期
 ** unauthorized 未授权
 ** quit  已退出
 */
export enum PlanInviteStatus {
  inviting = 'inviting',
  following = 'following',
  rejected = 'rejected',
  removed = 'removed',
  expired = 'expired',
  unauthorized = 'unauthorized',
  quit = 'quit',
}

export const STATE_LIST = [
  { name: '全部', stateId: '' },
  { name: '邀请中', stateId: PlanInviteStatus.inviting },
  { name: '随访中', stateId: PlanInviteStatus.following },
  { name: '已终止', stateId: PlanInviteStatus.removed }, // 需求要求修改 之前的删除对应终止
  { name: '已拒绝', stateId: PlanInviteStatus.rejected },
  { name: '已到期', stateId: PlanInviteStatus.expired },
  { name: '已退出', stateId: PlanInviteStatus.quit },
];

// 随访完成
export const FOLLOWUP_FINISH_LIST = [
  { name: '全部', followupFinish: '' },
  { name: '未提交过', followupFinish: 'uncommitted' },
  { name: '已经提交', followupFinish: 'submitted' },
];

//
export const ABNORMAL_ALERT_LIST = [
  { name: '全部', abnormalAlert: '' },
  { name: '有过异常', abnormalAlert: 'hasException' },
  { name: '未有异常', abnormalAlert: 'noException' },
];

export enum PatientSource {
  innerHospital = 'innerHospital',
  outerHospital = 'outerHospital',
  jiayi = 'jiayi',
}

// 加入方式
export const METHOD_OF_JOIN_LIST = [
  {
    value: '',
    label: '全部',
  },
  {
    value: PatientSource.innerHospital,
    label: '院内',
  },
  {
    value: PatientSource.outerHospital,
    label: '院外',
  },
];

// 计划填写类型
export const PLAN_FILL_TYPE_LIST = [
  {
    value: 'patient',
    label: '患者填写',
  },
  {
    value: 'doctor',
    label: '仅医护填写',
  },
];

// 计划填写方式
export enum WriteSubject {
  doctor = 'doctor',
  patient = 'patient',
}

// 首页、智能随访、诊后拉取二维码
export enum QrCodeType {
  workbench = 1,
  followUp = 2,
  afterDiagnosisPlan = 3,
}

// 就诊日期、出院日期、入院日期、手术日期
export enum ConditionDateType {
  visitDate = 'visitDate',
  admissionDate = 'admissionDate',
  dischargeDate = 'dischargeDate',
  surgeryDate = 'surgeryDate',
}

export const CONDITION_DATE_LIST = [
  {
    value: ConditionDateType.visitDate,
    label: '就诊日期',
  },
  {
    value: ConditionDateType.dischargeDate,
    label: '出院日期',
  },
  {
    value: ConditionDateType.admissionDate,
    label: '入院日期',
  },
  {
    value: ConditionDateType.surgeryDate,
    label: '手术日期',
  },
];

/*
 ** 计划完成状态
 ** completed:  已完成
 ** doctorCompleted:  已完成(医生完成)
 ** incomplete: 未完成
 ** notStarted: 未开始
 ** expired:    已过期
 */
export enum PlanCompleteStatus {
  completed = 'completed',
  incomplete = 'incomplete',
  notStarted = 'notStarted',
  expired = 'expired',
  doctorCompleted = 'doctorCompleted',
}

export const EDIT_STATUS_LIST = [
  { label: '未开始', value: PlanCompleteStatus.notStarted, disabled: true },
  { label: '未完成', value: PlanCompleteStatus.incomplete, disabled: true },
  { label: '已完成', value: PlanCompleteStatus.completed, disabled: false },
  { label: '已过期', value: PlanCompleteStatus.expired, disabled: true },
];

/** 0 正常计分
 ** 1 复杂计分
 ** 2 直接计分
 */
export enum ScoreType {
  normalScore,
  complexScore,
  directScore,
}

export const SCORE_TYPE_LIST = [
  {
    label: '正常计分',
    value: ScoreType.normalScore,
  },
  {
    label: '复杂计分',
    value: ScoreType.complexScore,
  },
  {
    label: '直接计分',
    value: ScoreType.directScore,
  },
];

/*
 ** 0 待确定
 ** 1 已同意
 ** 2 已否决
 */
export enum PlanApplyState {
  toBeDetermined,
  approved,
  rejected,
}

// 计划修改
export const PLAN_MODIFY_LIST = [
  {
    label: '不可修改计划',
    value: 0,
  },
  {
    label: '可修改计划',
    value: 1,
  },
];

// 管理师查看权限
export const ADMINISTRATOR_VIEWS_LIST = [
  {
    label: '可查看所有患者',
    value: 'all',
  },
  {
    label: '只查看管理患者',
    value: 'self',
  },
];

// 邀请患者
export const INVITE_PATIENTS_LIST = [
  {
    label: '不可邀请患者',
    value: 0,
  },
  {
    label: '可邀请患者',
    value: 1,
  },
];

export const topicNameMap = {
  [QuestionnaireSubjectType.single_choice]: '单选题',
  [QuestionnaireSubjectType.multi_radio]: '多选题',
  [QuestionnaireSubjectType.select]: '上下滚动题',
  [QuestionnaireSubjectType.text]: '输入文本题',
  [QuestionnaireSubjectType.number]: '数字输入题',
  [QuestionnaireSubjectType.enclosure]: '附件题（图片/视频）',
  [QuestionnaireSubjectType.address]: '地址选择题',
  [QuestionnaireSubjectType.date]: '日期选择题',
  [QuestionnaireSubjectType.description]: '说明文字题',
};

/*
 ** 0 不自动创建群聊
 ** 1 自动创建群聊
 ** 2 自动创建群聊并下发消息
 */
export enum AutoCreateGroupType {
  off,
  on,
  onAndSendMessage,
}

//  数据提交提醒
export const REMINDER_OPTIONS_LIST = [
  {
    label: '计划提交',
    value: 'followUp',
  },
  {
    label: '运动记录提交',
    value: 'sport',
  },
  {
    label: '饮食记录提交',
    value: 'diet',
  },
];

export enum QuestionnaireModeType {
  // 问卷模式
  normal = 'formMode',
  // 固定模板
  richtext = 'fixedMode',
}

export const QUESTIONNAIRE_MODE_LIST = [
  {
    label: '问卷模式',
    value: QuestionnaireModeType.normal,
  },
  {
    label: '固定模板',
    value: QuestionnaireModeType.richtext,
  },
];

// 时间前后
export const TIME_LIST = [
  {
    label: '后',
    value: 1,
  },
  {
    label: '前',
    value: 2,
  },
];

export const MATCH_TIME = [
  { value: '0:00' },
  { value: '2:00' },
  { value: '4:00' },
  { value: '6:00' },
  { value: '8:00' },
  { value: '8:30' },
  { value: '9:00' },
  { value: '9:30' },
  { value: '10:00' },
  { value: '10:30' },
  { value: '11:00' },
  { value: '11:30' },
  { value: '12:00' },
  { value: '12:30' },
  { value: '13:00' },
  { value: '13:30' },
  { value: '14:00' },
  { value: '14:30' },
  { value: '15:00' },
  { value: '15:30' },
  { value: '16:00' },
  { value: '16:30' },
  { value: '17:00' },
  { value: '17:30' },
  { value: '18:00' },
  { value: '18:30' },
  { value: '19:00' },
  { value: '21:00' },
  { value: '23:00' },
];

export const INSPECTION_LIST = [
  {
    type: '检查',
    itemList: [
      '超声',
      'X 线',
      'CT',
      'MR',
      '乳腺钼靶',
      '核医学',
      '其它检查报告',
    ],
  },
  {
    type: '检验',
    itemList: [
      '血液一般检查',
      '尿液一般检查',
      '粪便一般检查',
      '精液常规检查',
      '阴道分泌物常规检查',
      '溶血检查',
      '出凝血检查',
      '骨髓检查与染色技术',
      '血型、输血及人类组织相关性抗原检测',
      '体液与分泌物检查',
      '血液流变学检查',
      '蛋白质及多肽类检验',
      '糖及其代谢物测定',
      '血脂及脂蛋白测定',
      '维生素、氨基酸与血药浓度测定',
      '无机物及血气分析',
      '甲状腺功能检测',
      '人绒毛膜促性腺激素',
      '骨质疏松的实验诊断',
      '激素测定',
      '其他酶类的测定',
      '肝功能检测',
      '肾功能检测',
      '心肌酶谱检测',
      '肝肾功能检测',
      '生化一般检验',
      '丙肝检查',
      '乙肝检查',
      '肿瘤相关抗原测定',
      '免疫功能测定',
      '免疫球蛋白检测',
      '自身抗体检测',
      '感染性疾病实验检测',
      '变应原相关项目测定',
      '补体检查',
      '产前筛查',
      '穿刺液常规检查',
      '胸腹水常规检查',
      '骨髓涂片细胞学检验',
      '脑脊液常规检查',
      '人乳头瘤病毒基因分型检测',
      '一氧化碳定性测定',
      '红斑狼疮细胞检查',
      '新型冠状病毒核酸检测',
      '基因检测',
    ],
  },
  {
    type: '体检',
    itemList: ['体检报告'],
  },
];
